import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useStyles } from './NotificationType.styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import { Chip, Stack } from '@mui/material';
import { Collapse } from '@material-ui/core';

export interface INotificationType {
  id: number;
  value: string;
}

export enum INotificationTypeId {
  SYSTEM,
  EMAIL,
  SMS,
  PUSH,
}

export interface INotificationTypeProps {
  onNotificationTypeChange: (ids: INotificationTypeId[]) => void;
  openTypeList: boolean;
  isSmsEnabled?: boolean;
}

export const NotificationType: React.FC<INotificationTypeProps> = (props) => {
  const notificationType = [
    { id: INotificationTypeId.EMAIL, value: 'Email' },
    { id: INotificationTypeId.SMS, value: 'SMS' },
    { id: INotificationTypeId.PUSH, value: 'Push' },
  ];
  const classes = useStyles();
  const [checked, setChecked] = useState<INotificationTypeId[]>([]);
  const [notificationTypeEnabled, setNotificationTypeEnabled] = useState(notificationType);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked && checked.indexOf(value);
    const newChecked = checked && [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  useEffect(() => {
    props.onNotificationTypeChange(checked);
  }, [checked]);

  useEffect(() => {
    if (!props.isSmsEnabled) {
      setNotificationTypeEnabled(notificationTypeEnabled.filter((item) => item.id !== INotificationTypeId.SMS));
      const currentIndex = checked && checked.indexOf(INotificationTypeId.SMS);
      if (currentIndex !== -1) {
        const newChecked = checked && [...checked];
        newChecked.splice(currentIndex, 1);
        setChecked(newChecked);
      }
    } else {
      setNotificationTypeEnabled(notificationType);
    }
  }, [props.isSmsEnabled]);

  const getValue = (id: INotificationTypeId): string => {
    const result = notificationType.find((a: { id: INotificationTypeId }) => a.id === id);
    return result ? result.value : '';
  };

  return (
    <>
      <Collapse in={props.openTypeList} timeout="auto" style={{ position: 'absolute', bottom: '25px' }}>
        <List
          sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
          style={{
            border: '1px solid rgba(44, 45, 62, 0.3)',
            borderRadius: '5px',
            width: '200px',
            boxShadow: '0px 0px 3px 3px rgba(171,169,171,0.37)',
          }}
        >
          <ListItem style={{ padding: '0px' }}>
            <ListItemButton role={undefined} dense>
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-label': 'Wewnątrz systemu' }}
                  disabled
                />
              </ListItemIcon>
              <ListItemText primary="Wewnątrz systemu" />
            </ListItemButton>
          </ListItem>
          {notificationTypeEnabled.map((item) => {
            return (
              <ListItem key={item.id} style={{ padding: '0px' }}>
                <ListItemButton role={undefined} onClick={handleToggle(item.id)} dense>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={checked.indexOf(item.id) !== -1}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ 'aria-label': item.value }}
                    />
                  </ListItemIcon>
                  <ListItemText id={item.value} primary={item.value} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Collapse>
      <div className={classes.chipsContainer}>
        <Stack direction="row" spacing={1}>
          {checked.map((item) => {
            return (
              <Chip
                key={item}
                style={{ backgroundColor: 'rgb(235, 236, 244)', marginTop: '3px' }}
                label={getValue(item)}
                variant="outlined"
                onDelete={handleToggle(item)}
              />
            );
          })}
        </Stack>
      </div>
    </>
  );
};
